/**
 * Firebase Configuration for Ochtopus Website
 */

/// <reference types="vite/client" />

import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: (import.meta as unknown as { env: Record<string, string> }).env.VITE_FIREBASE_API_KEY || '',
  authDomain: (import.meta as unknown as { env: Record<string, string> }).env.VITE_FIREBASE_AUTH_DOMAIN || '',
  projectId: (import.meta as unknown as { env: Record<string, string> }).env.VITE_FIREBASE_PROJECT_ID || '',
  storageBucket: (import.meta as unknown as { env: Record<string, string> }).env.VITE_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: (import.meta as unknown as { env: Record<string, string> }).env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: (import.meta as unknown as { env: Record<string, string> }).env.VITE_FIREBASE_APP_ID || '',
  measurementId: (import.meta as unknown as { env: Record<string, string> }).env.VITE_FIREBASE_MEASUREMENT_ID || '',
};

// Singleton instances
let app: FirebaseApp;
let auth: Auth;
let db: Firestore;

// Initialize Firebase
export function initializeFirebase(): FirebaseApp {
  if (getApps().length === 0) {
    app = initializeApp(firebaseConfig);
  } else {
    app = getApps()[0];
  }
  return app;
}

// Get Auth instance
export function getFirebaseAuth(): Auth {
  if (!auth) {
    const app = initializeFirebase();
    auth = getAuth(app);
  }
  return auth;
}

// Get Firestore instance
export function getFirebaseFirestore(): Firestore {
  if (!db) {
    const app = initializeFirebase();
    db = getFirestore(app);
  }
  return db;
}

// Check if Firebase is configured
export function isFirebaseConfigured(): boolean {
  return Boolean(
    firebaseConfig.apiKey &&
    firebaseConfig.authDomain &&
    firebaseConfig.projectId
  );
}

export { firebaseConfig };
